// NPM Imports
import React, { Fragment } from "react";
import moment from "moment";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

// Services Imports
import { getBillingInfo } from "../../actions/SettingsActions/settingsService";

// component Imports
import PlanChangeRequest from "../SettingsWrapper/BillingSettings/PlanChangeRequest";
import ShowPlanSubscribeRequestPopup from "../ShowPlanSubscribeRequestPopup";
import BillingBandLeftDaysSection from "./BillingBandLeftDaysSection";
import TrialEndBandSection from "./TrialEndBandSection";

// Action Imports
import { SettingsActions } from "../../actions";

import {
  readDataFromLocalStorage,
  writeDataToLocalStorage,
  removeDataFromLocalStorage,
} from "../../utils/globalUtils";

// Destructuring
const { billingBandNotifyAction } = SettingsActions;

const BILLING_BAND_CANCEL_DAYS_POSSIBILITY = 2;
const BILLING_BAND_SHOW_START_DAYS = 5;
const BILLING_BAND_SHOW_END_DATE = 1;

class BillingBandInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showBillingBand: false,
      showDayLeftBand: false,
      showContactUsBand: false,
      daysLeft: 0,
      planId: "",
      contactUsPopup: false,
      planSubscribeRequestPopup: false,
    };
  }

  componentDidUpdate() {
    if (this.props.billingBandNotify) {
      this.props.billingBandNotifyAction(false);
      this._billingInfoApiCall();
    }
  }

  _billingInfoApiCall = () => {
    if (
      readDataFromLocalStorage("billingBandClosedDate") === undefined ||
      readDataFromLocalStorage("billingBandClosedDate") !== moment().format("L")
    ) {
      getBillingInfo()
        .then(res => {
          removeDataFromLocalStorage("billingBandClosedDate");
          if (
            res.subscription &&
            res.subscription.status === "in_trial" &&
            !res.payment_source.last_four_digit
          ) {
            this.setState({
              planId: res.subscription.plan_id,
              showBillingBand: true,
              showDayLeftBand: true,
              daysLeft: this._showPlanDayLeft(res.subscription.trial_end),
            });
          } else if (
            res.subscription &&
            res.auto_downgraded === true &&
            !res.payment_source.last_four_digit
          ) {
            this.setState({
              planId: res.subscription.plan_id,
              showBillingBand: true,
              showContactUsBand: true,
              showDayLeftBand: false,
              daysLeft: 0,
            });
          } else {
            this.setState({
              planId: "",
              showBillingBand: false,
              showContactUsBand: false,
              showDayLeftBand: false,
              daysLeft: 0,
            });
          }
        })
        .catch(err => {
          console.error(err);
        });
    }
  };

  _hideBillingBand = () => {
    writeDataToLocalStorage("billingBandClosedDate", moment().format("L"));
    this.setState({
      showBillingBand: false,
    });
  };

  _showPlanDayLeft = value => {
    const planEnd = moment.unix(value);
    const current = moment();
    const planEndDate = moment(planEnd, "DD-MM-YYYY");
    const currentDate = moment(current, "DD-MM-YYYY");
    return planEndDate.diff(currentDate, "days") + 1;
  };

  _actionOnTextClick = async () => {
    this.setState({
      planSubscribeRequestPopup: true,
    });
  };

  _closePopUp = incomingPopupState => {
    this.setState({
      [incomingPopupState]: false,
    });
  };

  _getMainMessage = () => {
    const { showDayLeftBand, daysLeft, showContactUsBand } = this.state;
    let message = "";
    if (showDayLeftBand && daysLeft <= BILLING_BAND_SHOW_START_DAYS) {
      if (daysLeft === BILLING_BAND_SHOW_END_DATE) {
        message = `Your trial is about to expire in a day. ${" "}`;
      } else {
        message = `Your trial is about to expire in ${daysLeft} days. ${" "}`;
      }
    } else if (!showDayLeftBand && showContactUsBand) {
      message = `Your free trial for the Pro Plus plan has expired. ${" "}`;
    }
    return message;
  };

  _getSecondaryMessage = () => {
    const { showDayLeftBand, daysLeft, showContactUsBand } = this.state;
    let secondaryMessage = "";
    if (showDayLeftBand && daysLeft <= BILLING_BAND_SHOW_START_DAYS) {
      secondaryMessage = "Subscribe now to continue using Pro Plus features.";
    } else if (!showDayLeftBand && showContactUsBand) {
      secondaryMessage = "Upgrade now to access the premium features in Revv. ";
    }
    return secondaryMessage;
  };

  render() {
    const {
      showBillingBand,
      daysLeft,
      planId,
      contactUsPopup,
      showDayLeftBand,
      showContactUsBand,
      planSubscribeRequestPopup,
    } = this.state;
    return (
      <Fragment>
        {contactUsPopup && planId && (
          <PlanChangeRequest
            currentPlan={planId}
            onClose={() => this._closePopUp("contactUsPopup")}
          />
        )}
        {planSubscribeRequestPopup && (
          <ShowPlanSubscribeRequestPopup
            onClose={() => this._closePopUp("planSubscribeRequestPopup")}
          />
        )}
        {showBillingBand && showDayLeftBand && !showContactUsBand && (
          <BillingBandLeftDaysSection
            mainMessage={this._getMainMessage()}
            secondaryMessage={this._getSecondaryMessage()}
            actionOnTextClick={this._actionOnTextClick}
            daysLeft={daysLeft}
            showStartDate={BILLING_BAND_SHOW_START_DAYS}
            cancleButtonVisibility={BILLING_BAND_CANCEL_DAYS_POSSIBILITY}
            hideBillingBand={this._hideBillingBand}
          />
        )}
        {showBillingBand && !showDayLeftBand && showContactUsBand && (
          <TrialEndBandSection
            mainMessage={this._getMainMessage()}
            secondaryMessage={this._getSecondaryMessage()}
            actionOnTextClick={this._actionOnTextClick}
          />
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const { SettingsStore } = state;
  return { billingBandNotify: SettingsStore.billingBandNotify };
};

const mapDispatchToProps = {
  billingBandNotifyAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(BillingBandInfo));



// WEBPACK FOOTER //
// ./src/components/BillingBandInfo/index.js